import { UserEvent, UserEventType } from '../core/user-events';
import { G2ReviewPromptCapacityResponse } from '../core/user-events/g2-review-prompt-capacity.interface';
import { HttpClient } from './http';

export interface UserEventsService {
  addUserEvent: (event: UserEventType, once?: boolean) => Promise<void>;
  getG2ReviewPromptCapacity: () => Promise<G2ReviewPromptCapacityResponse>;
  hasUserEvent: (event: UserEventType) => Promise<boolean>;
  listUserEvents: (filter?: UserEventType[]) => Promise<UserEvent[]>;
}

export function createUserEventsService(
  httpClient: HttpClient,
  baseUrl: string,
): UserEventsService {
  return {
    addUserEvent: (event: UserEventType, once?: boolean) => {
      return httpClient<void>(`${baseUrl}/user-events/${event}`, 'post', {
        body: { once },
      });
    },

    getG2ReviewPromptCapacity: () => {
      return httpClient<G2ReviewPromptCapacityResponse>(
        `${baseUrl}/user-events/g2-review-prompt-capacity`,
        'get',
      );
    },

    hasUserEvent: (event: UserEventType) => {
      return httpClient<boolean>(`${baseUrl}/user-events/has/${event}`, 'get');
    },

    listUserEvents: (filter?: UserEventType[]) => {
      return httpClient<UserEvent[]>(`${baseUrl}/user-events`, 'get', {
        query: { filter: filter?.join(',') || '' },
      });
    },
  };
}
